import React from 'react';

import {Icon} from '@edna/components/primitives';

import {TSubject, channelIconHash} from 'src/constants';

import * as S from './style';

type TProps = {
  className?: string;
  name?: TSubject['name'];
  icon?: TSvgComponentType | null;
  type: TSubject['type'];
};

const Subject = React.memo<TProps>(({className, type, name, icon}) => (
  <S.Subject className={className}>
    <Icon as={icon || channelIconHash[type]} size="20px" />
    <S.SubjectName title={name}>{name}</S.SubjectName>
  </S.Subject>
));

export default Subject;
